<template lang="pug">
.modal(:class="{'is-active': true}" )
  .modal-background(@click="$emit('close')")
  .modal-card
    .modal-card-head
      p.modal-card-title
        span.theme-name(v-if="row.parent") {{row.parent.title}}
        span.theme-sep(v-if="row.parent")  · 
        span.lesson-num(v-if="lessonDisplayIndex") Les {{lessonDisplayIndex}}
        span.theme-sep(v-if="lessonDisplayIndex")  · 
        span {{row.title}}
      button.delete(@click="$emit('close')")
    .modal-card-body
      .columns
        .column.is-one-quarter
          aside.menu
            p.menu-label Leerdoelen in deze les
            ul.menu-list
              li(v-for="group in visibleGroups")
                .field
                  .control
                    label.checkbox
                      input.cb(type="checkbox" v-model="selectedTargets" :value="group.title")
                      span {{group.title}}
                      span  ({{group.unfilteredLength}})
                ul(v-if="group.relevantFilter")
                  li
                    .field(v-if="group.relevantFilter")
                      .control
                        label.checkbox
                          input.cb(type="checkbox" :checked="localFilter" @change="handleFilterCheck")
                          span {{group.relevantFilter.title}}
                          span  ({{group.filteredLength}})

          br          
          .card
            .card-header
              p.card-header-title {{row.title}}
            .card-image
              figure.image.is-4by3(v-if="row.image")
                img(:src="row.image")
            .card-content
              p(v-if="row.description") {{row.description}}    
          
        .column
          .goal-group(v-for="group in filteredGroups")
            p.title.is-4 {{group.title}}
            template(v-if="group.themeHasGoals")
              p.subtitle.is-5
                | {{group.relevantGoals.length}}
                |  {{'leerdoel' | pluralize(group.relevantGoals.length)}}
                span.fltr(v-if="localFilter")
                  | (gefilterd op
                  .goal(:style="{'background-color': localFilter.color}")
                    | {{localFilter.title}}
                    a.is-small.delete(@click="localFilter = undefined")
                  | )
                |  in deze les:
              div(v-for="g in group.relevantParents")
                .goals
                  .goal(v-for="a in getAncestors(g)" :style="{'background-color': a.color}" @click="$emit('activate', a)") {{a.title}}
                  span(v-if="g.description") {{g.description}}
                ul.bullets
                  li(v-for="x in group.relevantChildrenOf(g)")
                    strong {{x.title}}
                    span(v-if="x.description")
                      | :
                      |  {{x.description}}
            .no-goals-info-modal(v-else)
              p de leerdoelen in dit thema worden nog toegevoegd
          
    .modal-card-foot
      button.button.is-pulled-left.is-medium.is-link
        .icon
          i.fas.fa-arrow-circle-left(@click="$emit('delta', -1)")
      .container
        nav.breadcrumb.is-centered
          ul
            li(v-for="ancestor in getAncestry()")
              a {{ancestor.title}}
            li.is-active
              a {{row.title}}
      button.button.is-pulled-right.is-medium.is-link
        .icon
          i.fas.fa-arrow-circle-right(@click="$emit('delta', 1)")


</template>

<script>
import _ from 'lodash'

// Temporary: only show these goal types in the checkbox list. Add more titles to show others again.
const VISIBLE_TARGET_TITLES = ['Kerndoelen Nederlands (2026)']

export default {
  props: ['row', 'target', 'targets', 'filter'],
  components: {
  },
  data() {
    return {
      localFilter: this.filter,
      selectedTargets: [this.target.title]
    }
  },
  computed: {
    themeDescendantTags() {
      const theme = (!this.row.hasChildren && this.row.parent) ? this.row.parent : this.row
      const collectTags = (n) => {
        let tags = [].concat(n.tags || [])
        if (n.children) {
          _.each(n.children, (c) => { tags = tags.concat(collectTags(c)) })
        }
        return tags
      }
      return _.uniq(collectTags(theme))
    },
    groups() {
      const descendants = (g) => {
        return [g].concat(g.hasChildren ? _.flatten(_.map(g.children, descendants)) : [])
      }

      return _.map(this.targets, (t) => {
        const all = descendants(t.tree)
        const allRowTags = this.row.tags
        //include all the tags of the descendant rows too if there are any
        _.forEach(descendants(this.row), (d) => {
          _.forEach(d.tags, (t) => allRowTags.push(t))
        })
        const relevant = _.filter(all, (g) => (allRowTags.indexOf(g.key) > -1) || (allRowTags.indexOf(g.code) > -1))
        let filtered = relevant
        let relevantFilter = this.filter
        if (this.filter) { //use prop here
          //is this filter under this current target?
          if (_.find(all, (g) => (g.key === this.filter.key))) {
            //yes

          } else {
            relevantFilter = undefined
          }
          const filterDescendantsKeys = _.flatten((_.map(descendants(this.filter), 'key')).concat(_.map(descendants(this.filter), 'code')))
          
          filtered = _.filter(relevant, (g) => {
            return (filterDescendantsKeys.indexOf(g.key) > -1)
          })
          
          

        }
        
        let maybeFiltered = this.localFilter ? filtered : relevant
        const themeHasGoals = _.some(all, (g) => (this.themeDescendantTags.indexOf(g.key) > -1) || (this.themeDescendantTags.indexOf(g.code) > -1))
        return {
          title: t.tree.title,
          allGoals: all,
          unfilteredLength: relevant.length,
          filteredLength: filtered.length,
          relevantGoals: maybeFiltered,
          relevantParents: _.uniq(_.map(maybeFiltered, (g) => g.parent)),
          relevantChildrenOf(parent) {
            return _.filter(maybeFiltered, (g) => g.parent === parent)
          },
          relevantFilter: relevantFilter,
          themeHasGoals: themeHasGoals
        }
      })
    },
    visibleGroups() {
      return _.filter(this.groups, (g) => VISIBLE_TARGET_TITLES.includes(g.title))
    },
    lessonDisplayIndex() {
      if (!this.row || !this.row.parent) return null
      if (this.row.hasChildren) return null // only for lessons (leaves), not themes
      const siblings = this.row.parent.children
      if (!siblings) return null
      const idx = siblings.indexOf(this.row)
      return idx >= 0 ? idx + 1 : null
    },
    filteredGroups() {
      return _.filter(this.visibleGroups, (g) => this.selectedTargets.indexOf(g.title) > -1)
    },
    allGoals () {
      const descendants = (g) => {
        return [g].concat(g.hasChildren ? _.flatten(_.map(g.children, descendants)) : [])
      }

      return descendants(this.target)
    },
    relevantGoals () {
      return _.filter(this.allGoals, (g) => (this.row.tags.indexOf(g.key) > -1) || (this.row.tags.indexOf(g.code) > -1))
    },
    relevantParents () {
      return _.uniq(_.map(this.relevantGoals, (g) => g.parent))
    },
    relevantRoots () {
      const grps = _.groupBy(this.relevantGoals, (g) => this.getAncestors(g)[0].key)
      console.log('roots', grps)
      return grps
    }
  },
  mounted() {
    // If current target isn't in visible list, default to first visible so content shows
    if (!VISIBLE_TARGET_TITLES.includes(this.target.title) && VISIBLE_TARGET_TITLES.length > 0) {
      this.selectedTargets = [VISIBLE_TARGET_TITLES[0]]
    }
    window.addEventListener('keyup', (evt) => {
      if (evt.keyCode === 39) { 
        this.$emit('delta', 1)
      } else if (evt.keyCode == 37) {
        this.$emit('delta', -1)
      } else if (evt.keyCode == 27) {
        //escape
        this.$emit('close')
      }
    })
  },
  methods: {
    getAncestors (g) {
      if (!g) return []
      return g.parent ? this.getAncestors(g.parent).concat([g]) : []
    },

    getAncestry() {
      let as = []
      let i = this.row.parent // skip me
      while (i) {
        as.push(i)
        i = i.parent
      }
      return _.reverse(as)
    },

    relevantChildren (parent) {
      return _.filter(this.relevantGoals, (g) => g.parent === parent)
    },
    findGoal (key) {
      return _.find(this.allGoals, (g) => g.key == key) || {color: 'white'}
    },
    handleFilterCheck() {
      if (this.localFilter) {
        this.localFilter = undefined
      } else {
        this.localFilter = this.filter
      }
    }
  }
}
</script>

<style scoped>
.modal-background {
  background-color: rgba(10,10,10,0.60)
}
.theme-name, .lesson-num {
  color: inherit;
  font-weight: 500;
}
.theme-sep {
  margin: 0 0.35em;
  opacity: 0.6;
}
.modal-card {
  width: auto;
  max-width: calc(100vw - 120px);
}
.goals {
  margin-top: 4px;
  
}
.goal {
  display: inline-block;
  font-size: 12px;
  padding: 4px;
  border: 1px solid #666;
  border-radius: 4px;
  margin-right: 4px;
  cursor: pointer;
}
.goal .delete {
  margin-left: 4px;
}
.bullets li::before {
  content: '\2022 ';
}
.cb {
  margin-right: 16px;
}
.goal-group {
  margin-bottom: 24px;
}
.fltr {
  margin: 0 4px;
}
.fltr .goal {
  margin-left: 4px;
}
.no-goals-info-modal {
  padding: 24px 0;
  color: #aaa;
  font-style: italic;
  font-size: 14px;
}
</style>
